<template>
  <div class="page dashboard_box">
    <div class="sub-header">
      <h2>دریافت استعلام نمره منفی گواهینامه</h2>
    </div>
    <div class="custom-box mar40t">
      <div class="custom-box-text" style="padding-top: 30px;">
        برای استعلام نمره منفی گواهینامه تنها کافی است شماره گواهینامه و کد ملی
        و تلفن همراه خود را در فرم زیر وارد نماید و با پرداخت 5200 تومان به
        عنوان هزینه استعلام، میزان نمره منفی گواهینامه خود را مشاهده کنید.
      </div>
      <div>
        <span class="icon-box">
          <i class="far fa-car"></i>
        </span>
      </div>
      <div>
        <input
          type="text"
          class="input modal-input"
          v-model="licenseNo"
          placeholder="شماره گواهینامه"
          maxlength="10"
          @keypress="isNumber($event)"
        />
        <input
          type="text"
          class="input"
          v-model="NationalityCodeInput"
          placeholder="کد ملی دارنده گواهینامه"
          maxlength="10"
          @keypress="isNumber($event)"
        />
        <input
          type="text"
          class="input"
          v-model="MobileInput"
          placeholder="تلفن همراه دارنده گواهینامه"
          maxlength="11"
          @keypress="isNumber($event)"
        />
        <input
          v-if="this.CodeFlag"
          type="text"
          class="input"
          v-model="Code"
          placeholder="کد ارسال شده به تلفن همراه"
          maxlength="5"
          @keypress="isNumber($event)"
        />
        <span
          v-if="this.NationalityCodeActive == true && this.MobileActive == true"
        >
          <span v-if="this.userMobile == this.MobileInput">
            <a class="input primary-btn" @click="sendlicenseNo">استعلام</a>
          </span>
          <span v-else-if="this.userMobile != this.MobileInput && !this.Code">
            <a class="input primary-btn" @click="sendOtp">استعلام</a>
          </span>
          <span v-else-if="this.userMobile != this.MobileInput && this.Code">
            <a class="input primary-btn" @click="sendlicenseNo">استعلام</a>
          </span>
        </span>
        <span v-else>
          <div class="input primary-btn deactive">استعلام</div>
        </span>
      </div>
    </div>
    <div v-if="!loading">
      <div v-if="errorMessage">
        <div
          class="error-message"
          v-if="errorMessage"
          style="text-align: center; margin: 0 10px 0"
        >
          <h3 class="loading-title text-color">
            {{ errorMessage }}
          </h3>
        </div>
      </div>
      <div
        class="custom-box"
        v-else-if="!errorMessage && LicenseStatus.negPoint"
      >
        <div class="success-message">
          <h3 class="loading-title text-color">
            نمره منفی گواهینامه شما ({{ LicenseStatus.negPoint }}) است.
          </h3>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <div class="custom-box">
        <h3 class="loading-title text-color loading-box">
          در حال دریافت استعلام نمره منفی گواهینامه ، لطفا شکیبا باشید.
        </h3>
      </div>
      <loader />
    </div>
  </div>
</template>

<script>
import api, { BaseUrl_New } from "../../service";
import loader from "../../components/inquiry/Loader";
import { mapGetters } from "vuex";

export default {
  name: "license-negative-point-inquiry",
  components: {
    loader,
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  data() {
    return {
      errorMessage: null,
      loading: false,
      LicenseStatus: "",
      licenseNo: "",
      NationalityCodeInput: "",
      MobileInput: "",
      Code: "",
      baseUrl: BaseUrl_New,
      client: 3,
      NationalityCodeActive: false,
      MobileActive: false,
      CodeFlag: false,
      userMobile: "",
    };
  },
  methods: {
    isNumber: function(e) {
      var iKeyCode = e.which ? e.which : e.keyCode;
      if (iKeyCode != 46 && iKeyCode > 31 && (iKeyCode < 48 || iKeyCode > 57))
        e.preventDefault();
      return true;
    },
    sendOtp() {
      this.CodeFlag = true;
      api
        .getSendOtp(this.MobileInput)
        .then((response) => {
          if (response.data && response.data.status === 200) {
            this.errorMessage = response.data.messages[0];
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch((err) => {
          this.errorMessage =
            "لطفا دسترسی اینترنت خود را چک کرده و دوباره امتحان کنید.";
          this.errorMessage = err.response.data.messages[0];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sendlicenseNo() {
      // this.LicenseStatus = {
      //   negPoint: '0',
      //   ruleId: '0',
      //   allowable: '1',
      // }
      this.errorMessage = "";
      this.loading = true;
      api
        .getLicenseNegativePointInquiryByInfo(
          this.client,
          this.Code,
          this.MobileInput,
          this.NationalityCodeInput,
          this.licenseNo
        )
        .then((response) => {
          if (response.data && response.data.status === 200) {
            this.LicenseStatus = response.data.data;
          } else {
            if (
              response.data &&
              response.data.messages &&
              response.data.messages.length > 0
            ) {
              this.errorMessage = response.data.messages[0];
            }
          }
        })
        .catch((err) => {
          this.errorMessage =
            "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
          this.errorMessage = err.response.data.messages[0];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    api
      .getUserInformation()
      .then((response) => {
        if (response.data && response.data.status === 200) {
          this.userMobile = response.data.data.mobile;
          //console.log(response.data.data);
        } else {
          if (
            response.data &&
            response.data.Messages &&
            response.data.Messages.length > 0
          ) {
            this.errorMessage = response.data.Messages[0];
          }
        }
      })
      .catch(() => {
        this.errorMessage =
          "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  watch: {
    MobileInput(item) {
      if (item) {
        this.MobileActive = true;
      } else {
        this.MobileActive = false;
      }
    },
    NationalityCodeInput(item) {
      if (item) {
        this.NationalityCodeActive = true;
      } else {
        this.NationalityCodeActive = false;
      }
    },
  },
};
</script>

<style scoped></style>
